// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box_dCal_ {
	width: 100%;
	display: inline-flex;
	align-items: center;
	height: 100%;
	overflow-y: scroll;
	padding: 20px;
}
.email_pYPaP {
	max-width: 600px;
	margin: 20px auto;
	display: inline-flex;
	flex-direction: column;
	gap: 8px;
}

.header_rLVJ2 {
	border: 1px solid var(--border-color);
	display: flex;
	align-items: center;
	gap: 4px;
	border-radius: 6px;
	.iconBox_ISlV5 {
		border-right: 1px solid var(--border-color);
		min-width: 100px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: var(--white-color);
		height: 180px;
		.icon_hY2kB {
			display: inline-flex;
			flex-direction: column;
			gap: 2px;
			font-size: 20px;
			font-weight: 500;
			text-align: center;
			border-radius: 6px;
			overflow: hidden;
			box-shadow: 0px 0px 10px -4px var(--_10a37f-background);
			min-width: 70px;
			width: 70px;
			.month_TIalM {
				background: var(--_10a37f-background);
				color: var(--_16c0982e-background);
				font-size: 12px;
				padding: 2px;
			}
			.day_Y7mfy {
				color: var(--_10a37f-background);
				font-size: 28px;
				font-weight: 600;
			}
			.label__LvMR {
				border-top: 1px solid var(--border-color);
			}
		}
	}
	.content_KG5lQ {
		display: inline-flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		gap: 8px;
		min-width: 350px;
		width: 350px;
		border-right: 1px solid var(--border-color);
		.top_VUqnL {
			display: inline-flex;
			flex-direction: column;
			gap: 2px;
			b {
				font-size: 15px;
				font-weight: 600;
			}
			.buttonView_YJIj7 {
				text-align: left;
				line-height: 10px;
				color: var(--_10a37f-background);
				font-weight: 600;
				font-size: 13px;
				text-decoration: underline;
			}
		}
		ul {
			font-size: 12px;
			li {
				display: inline-flex;
				align-items: center;
				gap: 4px;
				span {
					width: 45px;
					color: var(--text-color-secondary);
				}
				p {
					font-size: 14px;
				}
			}
		}
		.buttons_k1XHp {
			display: flex;
			align-items: center;
			gap: 6px;
			button {
				padding: 4px 10px;
				border-radius: 4px;
				&.yes_rlFDs {
					display: inline-flex;
					align-content: center;
					background: var(--_10a37f-background);
					color: var(--_16c0982e-background);
					padding-right: 0px;
					gap: 6px;
					> div {
						border-left: 1px solid var(--_16c098-background);
						svg {
							color: var(--_16c0982e-background);
						}
					}
				}
				&.maybe_pFT7m {
					border: 1px solid var(--border-color);
				}
				&.no_CGygf {
					border: 1px solid var(--border-color);
				}
				&.more_nZa9t {
					color: var(--_3c3a3a-color);
				}
			}
		}
	}
	.events_A0pfI {
		display: inline-flex;
		flex-direction: column;
		gap: 2px;
		b {
			font-size: 16px;
		}
		span {
			font-size: 10px;
		}
		ul {
			display: inline-flex;
			flex-direction: column;
			li {
				font-size: 12px;
				display: inline-flex;
				flex-direction: column;
				gap: 2px;
				a {
					font-size: 10px;
					color: var(--text-color-secondary);
					text-decoration: underline;
				}
			}
		}
	}
}

.container_aeES4 {
	display: flex;
	align-items: flex-start;
	gap: 30px;
	border: 1px solid var(--border-color);
	font-size: 12px;
	padding: 16px;
	border-radius: 5px;
	color: 30px;
	.left_Xduo9 {
		max-width: calc(100% - 200px);
		display: inline-flex;
		flex-direction: column;
		gap: 4px;
		> div {
			display: inline-flex;
			flex-direction: column;
			gap: 4px;
		}
		a {
			color: var(--_10a37f-background);
			margin: 0 3px;
			text-decoration: underline;
		}
	}
	.right_f1onh {
		max-width: 200px;
		display: inline-flex;
		flex-direction: column;
		gap: 20px;
		> div {
			display: inline-flex;
			flex-direction: column;
			gap: 2px;
			b {
				font-size: 12px;
			}
		}
		a {
			color: var(--_10a37f-background);
			margin: 0 3px;
			text-decoration: underline;
		}
		.buttonJoin_jIw9o {
			width: 100%;
			padding: 10px;
			border-radius: 4px;
			background: var(--_10a37f-background);
			color: var(--_16c0982e-background);
			cursor: pointer;
			border: none;
			outline: none;
			&:hover {
				background: var(--_16c098-background);
			}
		}
	}
}

.footer_oNL1x {
	font-size: 10px;
	a {
		color: var(--_10a37f-background);
		margin: 0px 3px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/email.module.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,oBAAoB;CACpB,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;CAClB,aAAa;AACd;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,oBAAoB;CACpB,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,qCAAqC;CACrC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,kBAAkB;CAClB;EACC,2CAA2C;EAC3C,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR,eAAe;GACf,gBAAgB;GAChB,kBAAkB;GAClB,kBAAkB;GAClB,gBAAgB;GAChB,uDAAuD;GACvD,eAAe;GACf,WAAW;GACX;IACC,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;IACf,YAAY;GACb;GACA;IACC,gCAAgC;IAChC,eAAe;IACf,gBAAgB;GACjB;GACA;IACC,yCAAyC;GAC1C;EACD;CACD;CACA;EACC,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR;IACC,eAAe;IACf,gBAAgB;GACjB;GACA;IACC,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,0BAA0B;GAC3B;EACD;EACA;GACC,eAAe;GACf;IACC,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR;KACC,WAAW;KACX,kCAAkC;IACnC;IACA;KACC,eAAe;IAChB;GACD;EACD;EACA;GACC,aAAa;GACb,mBAAmB;GACnB,QAAQ;GACR;IACC,iBAAiB;IACjB,kBAAkB;IAClB;KACC,oBAAoB;KACpB,qBAAqB;KACrB,qCAAqC;KACrC,kCAAkC;KAClC,kBAAkB;KAClB,QAAQ;KACR;MACC,gDAAgD;MAChD;OACC,kCAAkC;MACnC;KACD;IACD;IACA;KACC,qCAAqC;IACtC;IACA;KACC,qCAAqC;IACtC;IACA;KACC,2BAA2B;IAC5B;GACD;EACD;CACD;CACA;EACC,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR;GACC,eAAe;EAChB;EACA;GACC,eAAe;EAChB;EACA;GACC,oBAAoB;GACpB,sBAAsB;GACtB;IACC,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR;KACC,eAAe;KACf,kCAAkC;KAClC,0BAA0B;IAC3B;GACD;EACD;CACD;AACD;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,SAAS;CACT,qCAAqC;CACrC,eAAe;CACf,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX;EACC,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;EACT;EACA;GACC,gCAAgC;GAChC,aAAa;GACb,0BAA0B;EAC3B;CACD;CACA;EACC,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT;GACC,oBAAoB;GACpB,sBAAsB;GACtB,QAAQ;GACR;IACC,eAAe;GAChB;EACD;EACA;GACC,gCAAgC;GAChC,aAAa;GACb,0BAA0B;EAC3B;EACA;GACC,WAAW;GACX,aAAa;GACb,kBAAkB;GAClB,qCAAqC;GACrC,kCAAkC;GAClC,eAAe;GACf,YAAY;GACZ,aAAa;GACb;IACC,qCAAqC;GACtC;EACD;CACD;AACD;;AAEA;CACC,eAAe;CACf;EACC,gCAAgC;EAChC,eAAe;CAChB;AACD","sourcesContent":[".box {\n\twidth: 100%;\n\tdisplay: inline-flex;\n\talign-items: center;\n\theight: 100%;\n\toverflow-y: scroll;\n\tpadding: 20px;\n}\n.email {\n\tmax-width: 600px;\n\tmargin: 20px auto;\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.header {\n\tborder: 1px solid var(--border-color);\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n\tborder-radius: 6px;\n\t.iconBox {\n\t\tborder-right: 1px solid var(--border-color);\n\t\tmin-width: 100px;\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tbackground: var(--white-color);\n\t\theight: 180px;\n\t\t.icon {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\tfont-size: 20px;\n\t\t\tfont-weight: 500;\n\t\t\ttext-align: center;\n\t\t\tborder-radius: 6px;\n\t\t\toverflow: hidden;\n\t\t\tbox-shadow: 0px 0px 10px -4px var(--_10a37f-background);\n\t\t\tmin-width: 70px;\n\t\t\twidth: 70px;\n\t\t\t.month {\n\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\tcolor: var(--_16c0982e-background);\n\t\t\t\tfont-size: 12px;\n\t\t\t\tpadding: 2px;\n\t\t\t}\n\t\t\t.day {\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tfont-size: 28px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t\t.label {\n\t\t\t\tborder-top: 1px solid var(--border-color);\n\t\t\t}\n\t\t}\n\t}\n\t.content {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tjustify-content: flex-start;\n\t\talign-items: flex-start;\n\t\tgap: 8px;\n\t\tmin-width: 350px;\n\t\twidth: 350px;\n\t\tborder-right: 1px solid var(--border-color);\n\t\t.top {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\tb {\n\t\t\t\tfont-size: 15px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t\t.buttonView {\n\t\t\t\ttext-align: left;\n\t\t\t\tline-height: 10px;\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 13px;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t\tul {\n\t\t\tfont-size: 12px;\n\t\t\tli {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 4px;\n\t\t\t\tspan {\n\t\t\t\t\twidth: 45px;\n\t\t\t\t\tcolor: var(--text-color-secondary);\n\t\t\t\t}\n\t\t\t\tp {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.buttons {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 6px;\n\t\t\tbutton {\n\t\t\t\tpadding: 4px 10px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\t&.yes {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-content: center;\n\t\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\t\tcolor: var(--_16c0982e-background);\n\t\t\t\t\tpadding-right: 0px;\n\t\t\t\t\tgap: 6px;\n\t\t\t\t\t> div {\n\t\t\t\t\t\tborder-left: 1px solid var(--_16c098-background);\n\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\tcolor: var(--_16c0982e-background);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.maybe {\n\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t}\n\t\t\t\t&.no {\n\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t}\n\t\t\t\t&.more {\n\t\t\t\t\tcolor: var(--_3c3a3a-color);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.events {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tgap: 2px;\n\t\tb {\n\t\t\tfont-size: 16px;\n\t\t}\n\t\tspan {\n\t\t\tfont-size: 10px;\n\t\t}\n\t\tul {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tli {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 2px;\n\t\t\t\ta {\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\tcolor: var(--text-color-secondary);\n\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.container {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 30px;\n\tborder: 1px solid var(--border-color);\n\tfont-size: 12px;\n\tpadding: 16px;\n\tborder-radius: 5px;\n\tcolor: 30px;\n\t.left {\n\t\tmax-width: calc(100% - 200px);\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tgap: 4px;\n\t\t> div {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 4px;\n\t\t}\n\t\ta {\n\t\t\tcolor: var(--_10a37f-background);\n\t\t\tmargin: 0 3px;\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n\t.right {\n\t\tmax-width: 200px;\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tgap: 20px;\n\t\t> div {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2px;\n\t\t\tb {\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t}\n\t\ta {\n\t\t\tcolor: var(--_10a37f-background);\n\t\t\tmargin: 0 3px;\n\t\t\ttext-decoration: underline;\n\t\t}\n\t\t.buttonJoin {\n\t\t\twidth: 100%;\n\t\t\tpadding: 10px;\n\t\t\tborder-radius: 4px;\n\t\t\tbackground: var(--_10a37f-background);\n\t\t\tcolor: var(--_16c0982e-background);\n\t\t\tcursor: pointer;\n\t\t\tborder: none;\n\t\t\toutline: none;\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--_16c098-background);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.footer {\n\tfont-size: 10px;\n\ta {\n\t\tcolor: var(--_10a37f-background);\n\t\tmargin: 0px 3px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `box_dCal_`,
	"email": `email_pYPaP`,
	"header": `header_rLVJ2`,
	"iconBox": `iconBox_ISlV5`,
	"icon": `icon_hY2kB`,
	"month": `month_TIalM`,
	"day": `day_Y7mfy`,
	"label": `label__LvMR`,
	"content": `content_KG5lQ`,
	"top": `top_VUqnL`,
	"buttonView": `buttonView_YJIj7`,
	"buttons": `buttons_k1XHp`,
	"yes": `yes_rlFDs`,
	"maybe": `maybe_pFT7m`,
	"no": `no_CGygf`,
	"more": `more_nZa9t`,
	"events": `events_A0pfI`,
	"container": `container_aeES4`,
	"left": `left_Xduo9`,
	"right": `right_f1onh`,
	"buttonJoin": `buttonJoin_jIw9o`,
	"footer": `footer_oNL1x`
};
export default ___CSS_LOADER_EXPORT___;
